// this is an autogenerated file from DesignSystem/PatientInformation/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PatientInformation(
  $patient_id: uuid
  $appointment_booking_id: uuid
  $search_from_patient: Boolean!
  $search_from_booking: Boolean!
) {
  vaxiom_patients(where: { _id: { _eq: $patient_id } })
    @include(if: $search_from_patient) {
    id
    _id
    human_readable_id
    person {
      id
      _id
      profile_pic_url
      gender
      birth_date
      greeting
      first_name
      last_name
      public_user {
        id
        account {
          id
          active
          email
        }
      }
    }
    tx_cards(where: { deleted: { _eq: false } }) {
      id
      txs(where: { deleted: { _eq: false } }) {
        id
        organization {
          _id
          name
        }
      }
    }
  }
  vaxiom_appointment_bookings(where: { _id: { _eq: $appointment_booking_id } })
    @include(if: $search_from_booking) {
    id
    local_start_date
    local_start_time
    duration
    state
    confirmation_status
    provider {
      id
      employment_contract {
        id
        person {
          id
          first_name
          last_name
        }
      }
    }
    assistant {
      id
      employment_contract {
        id
        person {
          id
          first_name
          last_name
        }
      }
    }
    appointment {
      id
      _id
      notes(where: { note: { _neq: "" }, visible_in_schedule: { _eq: true } }) {
        id
        note
        author_user {
          id
          person {
            id
            first_name
            last_name
          }
        }
      }
      type {
        id
        display_name
        display_color_id
      }
      tx {
        id
        tx_status_name {
          id
          name
        }
        tx_card {
          id
          name
        }
        organization {
          id
          name
        }
      }
      patient {
        id
        _id
        human_readable_id
        person {
          id
          _id
          profile_pic_url
          gender
          birth_date
          greeting
          first_name
          last_name
          public_user {
            id
            account {
              id
              active
              email
            }
          }
        }
      }
    }
  }
}

`